import {
  GetConfirmedInspection,
  PutConfirmedInspection,
  PostBlockList,
} from '../../services/apiTypes';
import {
  createHeaderWithCredentials,
  fetchWithAuth,
  getApiUrl,
  getHeader,
} from '../../services/apiUtils';

export interface ConfirmedInspectionParam {
  rmaNo: string;
}

const endPoint = 'confirmed-inspection';
const endPointUpload = 'confirmed-inspection/diagnostic';
const endPointUploadBlock = 'confirmed-inspection/diagnostic/upload/stage';
const endPointUploadCommit = 'confirmed-inspection/diagnostic/upload/commit';

export const fetchConfirmedInspection = async (
  params: ConfirmedInspectionParam,
): Promise<GetConfirmedInspection> => {
  const queryParams = new URLSearchParams();
  queryParams.append('rmaNo', params.rmaNo);
  const apiUrl = getApiUrl(endPoint);
  const url = `${apiUrl}?${queryParams.toString()}`;
  const header = getHeader({
    method: 'GET',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};

export const updateConfirmedInspection = async (
  newConfirmedInspection: PutConfirmedInspection,
): Promise<void> => {
  const url = getApiUrl(endPoint);
  const header = getHeader({
    method: 'PUT',
    body: JSON.stringify(newConfirmedInspection),
    contentType: 'application/json',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};

export const deleteFiles = async (
  containerName: string,
  prefix: string,
): Promise<void> => {
  const queryParams = new URLSearchParams();
  queryParams.append('containerName', containerName);
  queryParams.append('prefix', prefix);
  const apiUrl = getApiUrl(endPointUpload);
  const url = `${apiUrl}?${queryParams.toString()}`;
  const header = getHeader({ method: 'DELETE' });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};

export const uploadBlockData = async (
  uploadBlockData: FormData,
): Promise<void> => {
  const url = getApiUrl(endPointUploadBlock);
  const header = getHeader({
    method: 'POST',
    body: uploadBlockData,
    contentType: 'multipart/form-data',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};

export const uploadBlockList = async (
  uploadBlockList: PostBlockList,
): Promise<void> => {
  const url = getApiUrl(endPointUploadCommit);
  const header = getHeader({
    method: 'POST',
    body: JSON.stringify(uploadBlockList),
    contentType: 'application/json',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};
